import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material';

export default function CleanupConfirmDialog({
  open,
  title,
  description = null,
  content = null,
  confirmLabel = 'Bestätigen',
  onConfirm,
  onClose,
  confirmDisabled = false,
}) {
  const handleSubmit = event => {
    event.preventDefault();
    if (confirmDisabled) {
      return;
    }
    onConfirm();
  };

  const handleKeyDown = event => {
    if (event.key !== 'Enter' || event.shiftKey) {
      return;
    }

    const targetTagName = event.target?.tagName;
    if (targetTagName === 'TEXTAREA') {
      return;
    }

    handleSubmit(event);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onKeyDown={handleKeyDown}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {content}
        {!content && description ? <Typography>{description}</Typography> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button color='error' type='submit' disabled={confirmDisabled} autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

